var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetaMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_4403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6518 0.107178L16.9248 8.78852L19.1041 3.67081L28.6518 0.107178Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59863 0.107178L13.2273 8.8689L11.1463 3.67081L1.59863 0.107178Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4276 20.2386L21.3105 25.008L27.9912 26.8478L29.9026 20.3458L24.4276 20.2386Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.357422 20.3458L2.25981 26.8478L8.93158 25.008L5.82345 20.2386L0.357422 20.3458Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57404 12.1825L6.71631 14.9869L13.3256 15.2906L13.1023 8.17224L8.57404 12.1825Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6853 12.1825L17.0766 8.08295L16.9248 15.2817L23.5341 14.978L21.6853 12.1825Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93115 25.008L12.9324 23.0788L9.4849 20.3904L8.93115 25.008Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3179 23.0699L21.3102 25.008L20.7654 20.3904L17.3179 23.0699Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 25.008L17.3179 23.0788L17.6394 25.6689L17.6037 26.7675L21.3102 25.008Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93115 25.008L12.6466 26.7675L12.6198 25.6689L12.9324 23.0788L8.93115 25.008Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7097 18.6756L9.38721 17.7021L11.7272 16.6214L12.7097 18.6756Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.541 18.6756L18.5145 16.6303L20.8724 17.711L17.541 18.6756Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93138 25.008L9.51192 20.2386L5.82324 20.3458L8.93138 25.008Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7388 20.2386L21.3104 25.008L24.4274 20.3458L20.7388 20.2386Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5341 14.9869L16.9248 15.2906L17.5411 18.6845L18.5146 16.6392L20.8725 17.72L23.5341 14.9869Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39573 17.7021L11.7358 16.6214L12.7093 18.6667L13.3256 15.2727L6.71631 14.9691L9.39573 17.7021Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71631 14.9869L9.48505 20.3904L9.39573 17.7021L6.71631 14.9869Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8728 17.7021L20.7656 20.3904L23.5344 14.9869L20.8728 17.7021Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3257 15.2816L12.7095 18.6756L13.4865 22.6769L13.6562 17.3984L13.3257 15.2816Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.925 15.2816L16.6035 17.3895L16.7643 22.6769L17.5413 18.6756L16.925 15.2816Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5412 18.6756L16.7642 22.6769L17.3179 23.0699L20.7654 20.3815L20.8726 17.6931L17.5412 18.6756Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.396 17.7021L9.48531 20.3904L12.9328 23.0788L13.4866 22.6858L12.7096 18.6845L9.396 17.7021Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6125 26.7675L17.6482 25.6689L17.3445 25.4099H12.9146L12.6288 25.6689L12.6556 26.7675L8.93115 25.008L10.2351 26.0708L12.8699 27.8839H17.3803L20.024 26.0708L21.3101 25.008L17.6125 26.7675Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.318 23.0699L16.7643 22.6769H13.4865L12.9327 23.0699L12.6201 25.66L12.9059 25.401H17.3359L17.6396 25.66L17.318 23.0699Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.152 9.36014L30.1345 4.5729L28.6518 0.116119L17.3179 8.50272L21.6764 12.1825L27.8391 13.9777L29.1967 12.3879L28.6072 11.9592L29.545 11.1018L28.8215 10.548L29.7593 9.8335L29.152 9.36014Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.107422 4.56396L1.10774 9.3512L0.47361 9.82456L1.42927 10.5391L0.705827 11.0928L1.64363 11.9502L1.05415 12.3789L2.41173 13.9687L8.57441 12.1735L12.9329 8.49378L1.59897 0.107178L0.107422 4.56396Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8393 13.9777L21.6766 12.1825L23.5344 14.9869L20.7656 20.3904L24.4364 20.3458H29.9114L27.8393 13.9777Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57433 12.1825L2.41165 13.9777L0.357422 20.3458H5.82345L9.49426 20.3904L6.72552 14.9869L8.57433 12.1825Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9251 15.2817L17.3181 8.50272L19.1044 3.67975H11.1465L12.9328 8.50272L13.3258 15.2817L13.4776 17.4073L13.4865 22.6769H16.7554L16.7643 17.4073L16.9251 15.2817Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_4403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2507,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMask);
export default __webpack_public_path__ + "static/media/MetaMask.8bcca7d808b8f3b5cdb99e38626c11b8.svg";
export { ForwardRef as ReactComponent };